import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API_ROOT = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_ROOT,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

const ADMIN_TOKEN_KEY = "authoros_admin_token";

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
}

export function setAdminToken(tok) {
  if (tok) localStorage.setItem(ADMIN_TOKEN_KEY, tok);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

// Auto-attach admin bearer token to /admin/* requests
api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.startsWith("/admin/")) {
    const tok = getAdminToken();
    if (tok) config.headers = { ...config.headers, Authorization: `Bearer ${tok}` };
  }
  return config;
});

// ---------- Public ----------
export async function getConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function submitConsult(payload) {
  const { data } = await api.post("/consults", payload);
  return data;
}

export async function createOrder(payload) {
  const { data } = await api.post("/orders/create", payload);
  return data;
}

export async function verifyPayment(payload) {
  const { data } = await api.post("/orders/verify", payload);
  return data;
}

export async function getOrder(orderId) {
  const { data } = await api.get(`/orders/${orderId}`);
  return data;
}

// ---------- Admin ----------
export async function adminLogin({ email, password }) {
  const { data } = await api.post("/admin/login", { email, password });
  if (data.token) setAdminToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/admin/me");
  return data;
}

export async function adminListOrders(params = {}) {
  const { data } = await api.get("/admin/orders", { params });
  return data;
}

export async function adminListConsults(params = {}) {
  const { data } = await api.get("/admin/consults", { params });
  return data;
}

export async function publicOverrides() {
  const { data } = await api.get("/overrides");
  return data;
}

export async function adminSaveOverride(code, payload) {
  const { data } = await api.put(`/admin/overrides/${encodeURIComponent(code)}`, payload);
  return data;
}

export async function adminUploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const tok = getAdminToken();
  const resp = await axios.post(`${API_ROOT}/admin/upload-image`, form, {
    headers: {
      Authorization: tok ? `Bearer ${tok}` : undefined,
      "Content-Type": "multipart/form-data",
    },
  });
  return resp.data;
}

export function absoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return pathOrUrl;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  return `${BACKEND}${pathOrUrl}`;
}
